import { Paper, Stack, CircularProgress } from '@mui/material';

interface Props {
  isLoading?: boolean;
}

const Loading = ({ isLoading }: Props) => {
  if (!isLoading) return null;

  return (
    <Paper>
      <Stack flex={1} alignItems="center" px={3} py={6}>
        <CircularProgress />
      </Stack>
    </Paper>
  );
};

export default Loading;
